module.exports = {
  accountManager: '账号管理',
  accountType: '账号类型',
  mobileValid: '手机验证',
  setPhoneFirst: '请先输入手机号',
  phoneValid: '手机验证',
  resetPassword: '重置密码',
  passwordInconsistent: '密码不一致',
  pwdEditTips: '您的账号或密码已被修改，请重新登录。若非本人操作，请联系客服',
  change: '更换',
  editPassword: '修改密码',
  belongMerchant: '所属商户',
  merchantAccount: '商户账号',
  email: '邮箱',
  storeLoginPhone: '门店登录手机号',
  userName: '用户名',
  currentPassword: '当前密码',
  newLoginPassword: '新登录密码',
  editSuccess3s: '修改成功，3s后',
  reLogin: '重新登录',
  complete: '完成',
  changePhoneMustNeedValid: '更换登录手机需要进行身份验证,请选择验证方式',
  phoneNumberValid: '手机号验证',
  idValid: '身份信息验证',
  realName: '真实姓名',
  credentialsType: '证件类型',
  credentialsNumber: '证件号码',
  changeLoginPhone: '更换登录手机',
  validIsCurrentLoginPhone: '输入的手机号与当前登录账号不一致',
  passwordCouldNotIncludeSpace: '密码不能包含空格'
}
